import { type ReactNode } from 'react'
import { RawButton } from '@/components/Button'
import { Dropdown, DropdownItem, DropdownTitle } from '@/components/Dropdown'
import { Icon } from '@/components/Icon'
import styles from './JobsViewer.module.css'

export interface JobsViewerProps {
  consultationPreview: ReactNode
  title: ReactNode
  header: ReactNode
  children: ReactNode
}

export function JobsViewer({
  consultationPreview,
  title,
  header,
  children,
}: JobsViewerProps) {
  return (
    <div className={styles.root}>
      {consultationPreview}
      <div className={styles.jobsViewer}>
        {title}
        {header}
        <div className={styles.jobsTableContainer}>{children}</div>
      </div>
    </div>
  )
}

export interface JobsViewerTitleProps {
  count: ReactNode
}

export function JobsViewerTitle({ count }: JobsViewerTitleProps) {
  return (
    <div className={styles.jobsViewerTitleContainer}>
      <h3 className={styles.jobsViewerTitleText}>Jobs</h3>
      {count}
    </div>
  )
}

export interface JobCountProps {
  canViewArchived: boolean
  label: string
  totalJobs: number | null | undefined
  onViewActive: () => void
  onViewArchived: () => void
}

export function JobCount({
  canViewArchived,
  label,
  totalJobs,
  onViewActive,
  onViewArchived,
}: JobCountProps) {
  return canViewArchived ? (
    <div className={styles.jobCountContainer}>
      <Dropdown
        autoDismiss
        button={
          <RawButton className={styles.jobViewerActions}>
            {label}
            <span className={styles.resultCount}>({totalJobs ?? 0})</span>
            <Icon name="dropdown" />
          </RawButton>
        }
      >
        <DropdownTitle>Jobs</DropdownTitle>
        <DropdownItem onPress={onViewActive}>Active</DropdownItem>
        <DropdownItem onPress={onViewArchived}>Archived</DropdownItem>
      </Dropdown>
    </div>
  ) : (
    <div className={styles.jobCountContainer}>
      Jobs
      <span className={styles.resultCount}>({totalJobs ?? 0})</span>
    </div>
  )
}
